import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/app/contact/ContactClient.tsx");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/node_modules/next/dist/client/image-component.js");
